import React, { useMemo } from 'react'
import { SubmitHandler, useFormContext } from 'react-hook-form'
import FilterListV2, { TFilterItem } from '@/components/content/FilterListV2'
import { MultipleInputV2 } from '@/components/content/MultipleInputV2'
import { GetSingleBatchSettingsReq, SINGLE_PACK_SKU_AXIS_FLAG } from '@/services/outbound/singleBatchSetting/types'
import { useFeatureFlag } from '@/services/feature/useFeatureQueries'
import { useGetCutOffWarehouses } from '@/services/warehouse/useWareHouseQueries'
import { Select } from '@/components/content/Select'

export const INIT_FORM: GetSingleBatchSettingsReq = {
  warehouseCode: undefined,
  barcodes: [],
}

interface Props {
  isLoading?: boolean
  onSubmit: SubmitHandler<GetSingleBatchSettingsReq>
  onReset?: () => void
}

function SingleBatchSettingForm({ isLoading, onSubmit, onReset }: Props) {
  const { setValue, watch, handleSubmit, reset } = useFormContext<GetSingleBatchSettingsReq>()
  const values = watch()
  const { options: allWarehouseOptions } = useGetCutOffWarehouses()
  const warehouseOptions = allWarehouseOptions.filter((o) => o.value !== 'JPWH01')
  const { data: isSkuAxis = false } = useFeatureFlag(SINGLE_PACK_SKU_AXIS_FLAG)
  const keyLabel = isSkuAxis ? 'SKU ID' : '바코드'

  const filterList = useMemo<TFilterItem<GetSingleBatchSettingsReq>[]>(
    () => [
      {
        field: 'warehouseCode',
        label: '센터',
        // eslint-disable-next-line react/no-unstable-nested-components
        component: ({ isOnPanel }) => (
          <div style={{ width: isOnPanel ? '100%' : 140 }}>
            <Select
              value={values.warehouseCode}
              onValueChange={(v) => setValue('warehouseCode', v)}
              onClear={() => setValue('warehouseCode', undefined)}
              options={warehouseOptions}
              placeholder="선택"
              floatingBlockLabel={isOnPanel ? undefined : '센터'}
              optionMaxHeight={300}
            />
          </div>
        ),
        fieldWidth: 140,
      },
      {
        field: 'barcodes',
        label: keyLabel,
        // eslint-disable-next-line react/no-unstable-nested-components
        component: ({ isOnPanel }) => (
          <div style={{ width: isOnPanel ? '100%' : 140 }}>
            <MultipleInputV2 label={isOnPanel ? undefined : keyLabel} value={values.barcodes ?? []} onChange={(v) => setValue('barcodes', v)} />
          </div>
        ),
        fieldWidth: 140,
      },
    ],
    [values.warehouseCode, values.barcodes, warehouseOptions, keyLabel],
  )

  return (
    <FilterListV2<GetSingleBatchSettingsReq>
      list={filterList}
      onSearch={handleSubmit(onSubmit)}
      onReset={onReset || (() => reset(INIT_FORM))}
      isSubmitting={isLoading}
      initialValues={INIT_FORM}
    />
  )
}

export default SingleBatchSettingForm
